angular.module 'zc.master'

.component 'projectLinkTooltip',
  require: '?value'
  bindings:
    currentProjects: '<'
    previousProjects: '<'
    placement: '@'
  transclude: true
  template: """
  <span
    ng-if="!$ctrl.currentProjects.length && !$ctrl.previousProjects.length"
    ng-transclude>
  </span>
  <a
    tooltip-html-unsafe="{{$ctrl.html}}"
    tooltip-placement="{{$ctrl.placement || 'top'}}"
    tooltip-trigger="click"
    ng-transclude
    ng-if="$ctrl.currentProjects.length || $ctrl.previousProjects.length">
  </a>
  """
  controller: ($scope, $q, $translate, Meta) ->
    $ctrl = this
    generateHtml = (currentProjects, previousProjects) ->
      html = ''
      promises = {}
      increased_projects = difference currentProjects, previousProjects
      if increased_projects.length
        promises.increased_projects = $q.all(generateProjectLink(project) for project in increased_projects)
      decreased_projects = difference previousProjects, currentProjects
      if decreased_projects.length
        promises.decreased_projects = $q.all(generateProjectLink(project) for project in decreased_projects)
      $q.all(promises)
      .then ({increased_projects, decreased_projects}) ->
        if increased_projects
          html += """
          <p class="text-left">
            #{$translate.instant('master.directives.projectsLinkTooltip.siteIncreasePreviousMonth')}<br>
            #{increased_projects.join('<br>')}
          </p>
          """
        if decreased_projects
          html += """
          <p class="text-left">
            #{$translate.instant('master.directives.projectsLinkTooltip.siteReducedPreviousMonth')}<br>
            #{decreased_projects.join('<br>')}
          </p>
          """
        html

    difference = (projects1, projects2) ->
      projects1_apikeys = projects1.map (project) -> project.apikey
      projects2_apikeys = projects2.map (project) -> project.apikey
      diff_apikeys = _.difference projects1_apikeys, projects2_apikeys
      diff = []
      for project in projects1
        continue unless project.apikey in diff_apikeys
        diff.push project
      diff

    generateProjectLink = (project) ->
      Meta.getServices()
      .then (services) ->
        """
        <a
          href="#{services.zcs}sites/#{project.apikey}"
          target="_blank">
          #{project.apikey}
        </a>
        """

    $ctrl.$onInit = ->
      $scope.$watchGroup ['$ctrl.currentProjects', '$ctrl.previousProjects'], ([currentProjects, previousProjects]) ->
        return unless currentProjects and previousProjects
        generateHtml(currentProjects, previousProjects)
        .then (html) ->
          $ctrl.html = html
      , true

    return



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/directives/projects_link_tooltip.coffee